import api from '@swipekit/lib/api.js';

import CrudStore from '@swipekit/lib/crud-store';

let crud = new CrudStore({
	name: 'briefs',
	singular: 'brief',
});

const state = {
	...crud.state,

	viewCache: [],

	selection: [],

	generations: [],

	removeSelectionTrigger: false,
};
const getters = {
	...crud.getters,

	generations: function (state) {
		return state.generations;
	},
};
const actions = {
	...crud.actions,

	async init(store) {},

	async generate(store, resource) {
		const response = await api.briefs.generate(resource).catch((err) => {
			throw err;
		});
		return response;
	},

	consumePie: async (store, pie) => {
		//console.log(pie.workspace.briefs);
		store.commit('SET', pie.workspace.briefs || []);
	},

	async analyzeUrl(store, resource) {
		const response = await api.briefs.analyzeUrl(resource).catch((err) => {
			throw err;
		});
		return response;
	},

	async generateScript(store, resource) {
		const response = await api.briefs.generateScript(resource).catch((err) => {
			throw err;
		});
		return response;
	},

	async refreshGenerations(store, params) {
		const response = await api.briefs.loadGenerations(params).catch((err) => {
			throw err;
		});
		if (response) {
			store.state.generations = response;
		}
		return response;
	},

	async loadMoreGenerations(store, params) {
		const response = await api.briefs.loadGenerations(params).catch((err) => {
			throw err;
		});
		if (response) {
			store.state.generations = store.state.generations.concat(response);
		}
		return response;
	},

	async getGeneration(store, generationId) {
		let params = {
			id: generationId,
		};
		const response = await api.briefs.getGeneration(params).catch((err) => {
			throw err;
		});
		return response;
	},
};

const mutations = {
	...crud.mutations,
};

let store = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};

export default store;
